import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { enableES5 } from 'immer';

import styles from 'styles/main.scss';
import './external.scss';

import routes from 'main/routes';
import configureStore from 'main/store';

import GoogleAnalytics from 'components/common/GoogleAnalytics/GoogleAnalytics';

const store = configureStore();
const historySync = syncHistoryWithStore(browserHistory, store);
const targetNode = document.getElementById('attachmentPoint');
targetNode.classList.add(styles.pageContent);
enableES5();

render(
    <Provider store={store}>
        <div className={styles.pageContent} id="root" data-cy="root">
            <GoogleAnalytics history={historySync} />
            <Router history={historySync} routes={routes} />
        </div>
    </Provider>,
    targetNode
);
